module.exports = __webpack_public_path__ + "media/entities/69-fae26c83.png";